import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'
import { NoticeIconList, NoticeIconSelect, NoticeItem } from '@delon/abc/notice-icon'
import { _HttpClient } from '@delon/theme'
import { environment } from '@env/environment'
import { formatDistanceToNow, parse } from 'date-fns'
import { NzI18nService } from 'ng-zorro-antd/i18n'
import { NzMessageService } from 'ng-zorro-antd/message'
import { zip } from 'rxjs'
const { msUrl } = environment.api

@Component({
  selector: 'header-notify-content',
  template: `
    <notice-icon
      [data]="data"
      [count]="count"
      btnClass="alain-default__nav-item"
      btnIconClass="alain-default__nav-item-icon"
      (select)="select($event)"
      (clear)="clear($event)"
      (popoverVisibleChange)="loadData()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderNotifyContentComponent {
  @Input() records: any
  @Input() count = 0
  @Output() callbackEvent = new EventEmitter<any>()

  data: NoticeItem[] = [
    {
      title: '通知',
      list: [],
      emptyText: '你已查看所有通知',
      emptyImage: 'assets/images/notification/notification.svg',
      clearText: '清空通知',
    },
  ]

  constructor(
    private msg: NzMessageService,
    private nzI18n: NzI18nService,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
  ) {}

  private updateNoticeData(notices: NoticeIconList[]): NoticeItem[] {
    const data = this.data.slice()
    data.forEach((i) => (i.list = []))

    notices.forEach((item) => {
      const newItem = { ...item } as NoticeIconList

      if (typeof newItem.datetime === 'string') {
        newItem.datetime = parse(newItem.datetime, 'yyyy-MM-dd', new Date())
      }

      if (newItem.datetime) {
        newItem.datetime = formatDistanceToNow(newItem.datetime as Date, {
          locale: this.nzI18n.getDateLocale(),
        })
      }

      if (newItem.extra && newItem['status']) {
        newItem['color'] = (
          {
            todo: undefined,
            processing: 'blue',
            urgent: 'red',
            doing: 'gold',
          } as { [key: string]: string | undefined }
        )[newItem['status']]
      }

      data.find((w) => w.title === newItem['type'])!.list.push(newItem)
    })

    return data
  }

  loadData(): void {
    this.data = this.updateNoticeData(
      this.records.map((item: any) => {
        const { id, title, content, createdTime } = item
        return {
          id,
          avatar: 'assets/images/notification/message.png',
          title,
          datetime: new Date(createdTime),
          type: '通知',
        }
      }),
    )
  }

  clear(type: string): void {
    const ids = this.data?.[0].list.map((item: any) => item.id)
    this.data = [
      {
        title: '通知',
        list: [],
        emptyText: '你已查看所有通知',
        emptyImage: 'assets/images/notification/notification.svg',
        clearText: '清空通知',
      },
    ]
    zip(
      ...ids.map((id: string) => this.http.patch(`${msUrl.auth}/station_messages/${id}/mark`)),
    ).subscribe((res: any) => {
      this.msg.success(`清空了 ${type}`)
      this.callbackEvent.emit({})
      this.cdr.detectChanges()
    })
  }

  select(res: NoticeIconSelect): void {
    const title = res.item.title
    const id = res.item?.['id']
    const { data } = this

    data.forEach((i) => {
      const { list } = i
      const index = list.findIndex((item: any) => item.id == id)

      if (index > -1) {
        list.splice(index, 1)
      }
    })

    this.http.patch(`${msUrl.auth}/station_messages/${id}/mark`).subscribe((res: any) => {
      if (res.successful) {
        this.msg.info(`${title}`)
        this.callbackEvent.emit(res.item)
        this.cdr.detectChanges()
      }
    })
  }
}
